module.exports = __webpack_public_path__ + "img/faq-pricing.98900b4a.svg";